// @font-face для шрифта табло свободных мест (ZoneInfo) классического дизайна.
// Остальные шрифты подключаются через @fontsource (см. libs/design: applyDesignAssets).
// Подключается через глобальные стили классического дизайна (index.classic.styles.js).
export const lcdNovaFontFace = `
@font-face {
  font-family: 'Conv_LCDNOVA';
  src: url('/fonts/LCDNOVA.eot');
  src:
    local('☺'),
    url('/fonts/LCDNOVA.woff') format('woff'),
    url('/fonts/LCDNOVA.ttf') format('truetype'),
    url('/fonts/LCDNOVA.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}
`;
